module.exports = __webpack_public_path__ + "img/dna_gif.1b486c86.gif";